import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import Spinner from '../../../components/UI/Spinner/Spinner';
import { Alert, Nav } from 'reactstrap';
import ReactQuill, { Quill } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import Files from 'react-butterfiles';
import './reactQuill.css';

import classes from './EditPromotionDialog.module.css';

import Col from 'react-bootstrap/Col';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';

import MachineGroupSelector from '../../../components/MachineGroupSelector/MachineGroupSelector';
import PromotionTypeSelector from './PromotionTypeSelector/PromotionTypeSelector';
import HelperTooltip from '../../../components/UI/HelperTooltip/HelperTooltip';
import ActiveDays from './ActiveDaysCheckBox/ActiveDaysCheckBox';
import TimeperiodCheckBox from './TimeperiodCheckBox/TimeperiodCheckBox';
import SelectedUsers from './SelectedUsers/SelectedUsers';
import PromotionUserSelectorDialog from '../PromotionUserSelectorDialog/PromotionUserSelectorDialog';
import TimePeriodLimit from './TimePeriodLimit/TimePeriodLimit';
import dayjs from 'dayjs';

import promotionsUtil from '../../../services/util/promotionsUtil';
import statistics from '../../../services/api/statistics';

class EditPromotionDialog extends Component {
	state = {
		promotion: {
			startDate: null,
			dailyPeriodStart: null,
			dailyPeriodEnd: null,
			endDate: '',
			activeDays: null,
			description: '',
			name: '',
			promotedMachine: null,
			promotedMachineGroup: null,
			promotionType: null,
			promotedProductGroup: null,
			promotedProduct: null,
			headerImage: null
		},
		optionMachine: null,
		optionGroup: null,

		validated: false,
		timePeriodChecked: false,
		isGroupSelected: false,

		showUserSelector: false,
		currentLanguageID: 1
	};

	constructor(props) {
		super(props);
		this.ReactQuillRef = React.createRef();
	}

	componentDidMount() {
		let promotion = { ...this.props.promotion };

		if (!!this.props.promotion.params)
			promotion.params = this.props.promotion.params.map(item => {
				return { ...item };
			});
		this.setState({
			promotion: promotion,
			timePeriodChecked: promotion.dailyPeriodStart || promotion.dailyPeriodEnd,
			isGroupSelected: promotion && !!promotion.assignedGroupID
		});

		let optionMachine = this.props.machines.map(e => ({
			key: e.vmID,
			value: e.vmID,
			label: e.customName
		}));
		let optionGroup = this.props.machineGroups.map(e => ({
			key: e.id,
			value: e.id,
			label: e.name
		}));

		this.setState({
			optionMachine,
			optionGroup
		});
		/*
		if (this.ReactQuillRef && this.ReactQuillRef.current) {
			this.ReactQuillRef.current.getEditor().disable();
			this.ReactQuillRef.current.getEditingArea().disabled = true;
		}
		*/
	}

	getLocalisedParamStringValue(paramName) {
		const languageCode = this.props.languages
			? this.props.languages
					.filter(lang => lang.LanguageID == this.state.currentLanguageID)
					.map(lang => lang.Code.toLocaleUpperCase())
					.shift()
			: '';
		const paramValue = promotionsUtil.getParamValueByName(
			this.state.promotion,
			languageCode ? paramName + '_' + languageCode : paramName
		);
		return paramValue ? paramValue : '';
	}

	setLocalisedParamValue(paramName, value) {
		const languageCode = this.props.languages
			.filter(lang => lang.LanguageID == this.state.currentLanguageID)
			.map(lang => lang.Code)
			.shift()
			.toLocaleUpperCase();
		let promotion = { ...this.state.promotion };
		if (!!this.state.promotion.params)
			promotion.params = this.state.promotion.params.map(item => {
				return { ...item };
			});
		promotionsUtil.setParamValue(
			promotion,
			paramName + '_' + languageCode,
			value
		);

		this.setState({ promotion });
	}

	// Render user selector wizard
	renderUserSelectorDialog() {
		return (
			<Modal
				show={
					this.state.showUserSelector && this.state.paramToSetForUserSelection
				}
				onHide={() => this.hideUserSelectorDialog()}
				size="xs"
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<i className="fa fa-bullhorn" style={{ marginRight: '10px' }}></i>
						{this.props.t(
							'promotionManager.addPromotion.promotionUsers.wizard.dialogTitle'
						)}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ backgroundColor: 'white' }}>
					<PromotionUserSelectorDialog
						machines={this.state.optionMachine}
						onGenerate={(selectedID, startDate, endDate) => {
							statistics
								.getUsersPurchasedOnMachine({
									fromDate: new Date(startDate),
									toDate: new Date(endDate),
									machineID: selectedID
								})
								.then(result => {
									// Add the result to the selected user list.
									if (
										result &&
										result.data &&
										result.data &&
										result.data.emails &&
										result.data.emails.length > 0
									) {
										let selectedUsers = promotionsUtil.getParamValueByName(
											this.state.promotion,
											this.state.paramToSetForUserSelection
										);

										selectedUsers = selectedUsers ? selectedUsers : '';

										if (
											selectedUsers.trim().length > 0 &&
											selectedUsers.trim().lastIndexOf(',') !=
												selectedUsers.length - 1
										) {
											selectedUsers = selectedUsers + ', ';
										}
										selectedUsers =
											selectedUsers + result.data.emails.join(', ');
										const promotion = { ...this.state.promotion };
										promotionsUtil.setParamValue(
											promotion,
											this.state.paramToSetForUserSelection,
											selectedUsers
										);

										this.setState({ promotion }, () =>
											this.hideUserSelectorDialog()
										);
									}
								});
						}}
					></PromotionUserSelectorDialog>
				</Modal.Body>
			</Modal>
		);
	}

	handleLimitTypeChange = value => {
		let promotion = { ...this.state.promotion };
		promotionsUtil.setParamValue(
			promotion,
			promotionsUtil.promotionParameters.PROMOTION_EXECUTION_LIMIT_TYPE,
			value
		);

		this.setState({ promotion: promotion });
	};

	handleLimitSourceChange = value => {
		let promotion = { ...this.state.promotion };
		promotionsUtil.setParamValue(
			promotion,
			promotionsUtil.promotionParameters.PROMOTION_EXECUTION_LIMIT_SOURCE,
			value
		);

		this.setState({ promotion: promotion });
	};

	handleLimitValueChange = value => {
		let promotion = { ...this.state.promotion };
		promotionsUtil.setParamValue(
			promotion,
			promotionsUtil.promotionParameters.PROMOTION_EXECUTION_LIMIT_NUMBER,
			value
		);

		this.setState({ promotion: promotion });
	};

	hideUserSelectorDialog = () => {
		this.setState({
			showUserSelector: false,
			paramToSetForUserSelection: undefined
		});
	};

	showUserSelectorDialog = paramToSetForUserSelection => {
		debugger;
		this.setState({ showUserSelector: true, paramToSetForUserSelection });
	};

	inputChangeHandler = event => {
		let promotion = { ...this.state.promotion };
		promotion[event.target.name] = event.target.value;

		this.setState({ promotion: promotion });
	};

	inputParamChangeHandler = event => {
		this.setState({ [event.target.name]: event.target.value });
	};

	activeDaysChangeHandler = event => {
		let promotion = { ...this.state.promotion };
		let activeDays = [];
		if (promotion.activeDays) {
			activeDays = promotion.activeDays.split(',');
		}

		if (event.target.checked) {
			activeDays.push(event.target.value);
			promotion.activeDays = activeDays.toString();
		}
		if (!event.target.checked) {
			activeDays = activeDays.filter(i => i !== event.target.value);
			promotion.activeDays = activeDays.toString();
		}
		if (promotion.activeDays == '') {
			promotion.activeDays = null;
		}

		this.setState({ promotion: promotion });
	};

	timePeriodCheckedHandling = () => {
		let promotion = { ...this.state.promotion };
		if (this.state.timePeriodChecked) {
			promotion.dailyPeriodStart = null;
			promotion.dailyPeriodEnd = null;
			this.setState({
				timePeriodChecked: false,
				promotion: promotion
			});
		}
		if (!this.state.timePeriodChecked) {
			this.setState({
				timePeriodChecked: true,
				promotion: promotion
			});
		}
	};

	validationHandler = () => {
		const form = document.getElementById('editPromotionForm');
		if (form.checkValidity() === true) {
			this.props.onSave(this.state.promotion);
		} else {
			this.setState({ validated: true });
		}
	};

	defaultOnclickhandler = () => {
		let promotion = { ...this.state.promotion };
		this.setState({ promotion: promotion });
	};

	renderGeneralTab() {
		const { t } = this.props;
		return (
			<>
				<Row>
					<Col>
						<Form.Group>
							<Row>
								<Form.Label style={{ fontWeight: 'bold' }}>
									{t('promotionManager.addPromotion.promotionName.title')}
								</Form.Label>
								<HelperTooltip
									height={'100px'}
									width={'250px'}
									direction={'right'}
									id={'namehelper'}
									title={t(
										'promotionManager.addPromotion.promotionName.tooltip.title'
									)}
									content={t(
										'promotionManager.addPromotion.promotionName.tooltip.content'
									)}
								></HelperTooltip>
							</Row>

							<Form.Control
								required
								id="name"
								name="name"
								type="text"
								value={this.state.promotion.name}
								onChange={this.inputChangeHandler}
							/>
						</Form.Group>
					</Col>
				</Row>
				<PromotionTypeSelector
					id={'edit'}
					promotion={this.state.promotion}
					onChanged={promotion => {
						if (promotion.promotionTypeID == 6) {
							const paramValue = promotionsUtil.setParamValue(
								promotion,
								promotionsUtil.promotionParameters
									.promotionGeneralDiscountFixAmount,
								'Y'
							);
						}
						this.setState({ promotion });
					}}
					productTags={this.props.productTags}
				/>
				<hr></hr>
				{this.state.promotion.promotionTypeID != 5 &&
				this.state.promotion.promotionTypeID != 6 ? (
					<>
						<Row>
							<Form.Label style={{ fontWeight: 'bold' }}>
								{t('promotionManager.addPromotion.promotionDevice.title')}
							</Form.Label>
							<HelperTooltip
								height={'100px'}
								width={'300px'}
								direction={'top'}
								id={'machineGroups'}
								title={t(
									'promotionManager.addPromotion.promotionDevice.tooltip.title'
								)}
								content={t(
									'promotionManager.addPromotion.promotionDevice.tooltip.content'
								)}
							></HelperTooltip>
						</Row>
						<Row>
							<Col>
								<MachineGroupSelector
									optionGroup={this.state.optionGroup}
									optionMachine={this.state.optionMachine}
									isGroupSelected={this.state.isGroupSelected}
									selectedIDS={
										this.state.isGroupSelected
											? this.state.promotion.assignedGroupID
											: this.state.promotion.assignedVMID
									}
									onIsGroupSelectedChanged={(
										groupSelected,
										newItemSelection
									) => {
										const newPromotion = { ...this.state.promotion };
										if (groupSelected) {
											newPromotion.assignedVMID = null;
											newPromotion.assignedGroupID = newItemSelection;
										} else {
											newPromotion.assignedVMID = newItemSelection;
											newPromotion.assignedGroupID = null;
										}
										this.setState({
											promotion: newPromotion,
											isGroupSelected: groupSelected
										});
									}}
									onSelectionChanged={value => {
										const newPromotion = { ...this.state.promotion };
										if (this.state.isGroupSelected) {
											newPromotion.assignedVMID = null;
											newPromotion.assignedGroupID = value;
										} else {
											newPromotion.assignedVMID = value;
											newPromotion.assignedGroupID = null;
										}
										this.setState({ promotion: newPromotion });
									}}
								/>
							</Col>
						</Row>
					</>
				) : null}
			</>
		);
	}

	renderTimerIntervalTab() {
		const { t } = this.props;
		return (
			<>
				<Row>
					<Col xs={12} sm={12} md={6} lg={6}>
						<Row>
							<Form.Label style={{ fontWeight: 'bold' }}>
								{t('promotionManager.addPromotion.dateHandling.title')}
							</Form.Label>
							<HelperTooltip
								height={'110px'}
								width={'600px'}
								direction={'top'}
								id={'machineGroups'}
								title={t(
									'promotionManager.addPromotion.dateHandling.tooltip.title'
								)}
								content={t(
									'promotionManager.addPromotion.dateHandling.tooltip.content'
								)}
							></HelperTooltip>
						</Row>
						<Row>
							<Col xs={12} sm={12} md={12} lg={6}>
								<Form.Group controlId="startDate">
									<Row className={classes.padding}>
										<Form.Label className={classes.Label}>
											{t('promotionManager.addPromotion.startDate.title')}
										</Form.Label>
									</Row>
									<Form.Control
										required
										name="startDate"
										type="date"
										value={
											dayjs(this.state.promotion.startDate).format(
												'YYYY-MM-DD'
											) || ''
										}
										onChange={this.inputChangeHandler}
									/>
								</Form.Group>
							</Col>
							<Col xs={12} sm={12} md={12} lg={6}>
								<Form.Group controlId="endDate">
									<Row className={classes.padding}>
										<Form.Label className={classes.Label}>
											{t('promotionManager.addPromotion.endDate.title')}
										</Form.Label>
									</Row>
									<Form.Control
										name="endDate"
										type="date"
										value={
											dayjs(this.state.promotion.endDate).format(
												'YYYY-MM-DD'
											) || ''
										}
										onChange={this.inputChangeHandler}
									/>
								</Form.Group>
							</Col>
						</Row>
					</Col>
					{this.state.promotion.promotionTypeID != 6 ? (
						<Col
							xs={12}
							sm={12}
							md={6}
							lg={6}
							style={
								this.state.timePeriodChecked
									? {
											backgroundColor: 'white'
									  }
									: { backgroundColor: 'ghostwhite' }
							}
						>
							<TimeperiodCheckBox
								timePeriodChecked={this.state.timePeriodChecked}
								dailyPeriodStart={this.state.promotion.dailyPeriodStart}
								dailyPeriodEnd={this.state.promotion.dailyPeriodEnd}
								onChanged={this.inputChangeHandler}
								onChecked={this.timePeriodCheckedHandling}
							/>
						</Col>
					) : null}
				</Row>
				<hr></hr>
				<Row className={classes.padding}>
					<Form.Label style={{ fontWeight: 'bold' }}>
						{t('promotionManager.promotionTable.timePeriodLimit.title')}
					</Form.Label>
					<HelperTooltip
						height={'100px'}
						width={'300px'}
						direction={'right'}
						id={'machineGroups'}
						title={t(
							'promotionManager.promotionTable.timePeriodLimit.tooltip.title'
						)}
						content={t(
							'promotionManager.promotionTable.timePeriodLimit.tooltip.content'
						)}
					></HelperTooltip>
				</Row>
				<TimePeriodLimit
					timePeriodType={promotionsUtil.getParamValueByName(
						this.state.promotion,
						promotionsUtil.promotionParameters.PROMOTION_EXECUTION_LIMIT_TYPE
					)|| promotionsUtil.promotionLimitType.NOTLIMITED}
					timePeriodSource={promotionsUtil.getParamValueByName(
						this.state.promotion,
						promotionsUtil.promotionParameters.PROMOTION_EXECUTION_LIMIT_SOURCE
					)}					
					timePeriodValue={promotionsUtil.getParamValueByName(
						this.state.promotion,
						promotionsUtil.promotionParameters.PROMOTION_EXECUTION_LIMIT_NUMBER
					)}
					onTimePeriodSourceChange={this.handleLimitSourceChange}
					onTimePeriodTypeChange={this.handleLimitTypeChange}
					onTimePeriodValueChange={this.handleLimitValueChange}
				></TimePeriodLimit>
				<hr></hr>
				{this.state.promotion.promotionTypeID != 6 ? (
					<>
						<Row className={classes.padding}>
							<Form.Label style={{ fontWeight: 'bold' }}>
								{t('promotionManager.promotionTable.activeDays.title')}
							</Form.Label>
							<HelperTooltip
								height={'100px'}
								width={'300px'}
								direction={'right'}
								id={'machineGroups'}
								title={t(
									'promotionManager.promotionTable.activeDays.tooltip.title'
								)}
								content={t(
									'promotionManager.promotionTable.activeDays.tooltip.content'
								)}
							></HelperTooltip>
						</Row>
						<ActiveDays
							activeDays={
								this.state.promotion.activeDays
									? this.state.promotion.activeDays.split(',')
									: []
							}
							onChanged={this.activeDaysChangeHandler}
						/>
					</>
				) : null}
			</>
		);
	}

	renderUserLimits() {
		const { t } = this.props;

		return (
			<>
				<Row className={classes.padding}>
					<Form.Label style={{ fontWeight: 'bold' }}>
						{t('promotionManager.addPromotion.promotionUsers.title')}
					</Form.Label>
					<HelperTooltip
						height={'100px'}
						width={'300px'}
						direction={'top'}
						id={'usersToolTip'}
						title={t(
							'promotionManager.addPromotion.promotionUsers.tooltip.title'
						)}
						content={t(
							'promotionManager.addPromotion.promotionUsers.tooltip.content'
						)}
					></HelperTooltip>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={12} lg={12}>
						<SelectedUsers
							selectedUsers={promotionsUtil.getParamValueByName(
								this.state.promotion,
								promotionsUtil.promotionParameters.PROMOTION_SELECTED_USERS
							)}
							onChange={e => {
								const promotion = { ...this.state.promotion };
								promotionsUtil.setParamValue(
									promotion,
									promotionsUtil.promotionParameters.PROMOTION_SELECTED_USERS,
									e.target.value
								);
								this.setState({ promotion });
							}}
							onShowUserSelector={() =>
								this.showUserSelectorDialog(
									promotionsUtil.promotionParameters.PROMOTION_SELECTED_USERS
								)
							}
						/>
					</Col>
				</Row>
			</>
		);
	}

	renderLanguageSelector() {
		const { t } = this.props;

		const languageOptions = this.props.languages.map(language => (
			<option
				key={language.LanguageID}
				selected={language.LanguageID === this.state.currentLanguageID}
			>
				{language.Name}
			</option>
		));
		return (
			<>
				<Row>
					<Form.Label style={{ fontWeight: 'bold' }}>
						{t('promotionManager.addPromotion.language')}
					</Form.Label>
				</Row>
				<Form.Control
					as="select"
					disabled={this.props.disableRoleInput}
					onChange={e => {
						this.setState({
							currentLanguageID: this.props.languages[e.target.selectedIndex]
								.LanguageID
						});
					}}
					className={classes.BottomMargin}
				>
					{languageOptions}
				</Form.Control>
			</>
		);
	}

	getBase64(file) {
		const reader = new FileReader();
		//reader.readAsDataURL(file);
		reader.readAsDataURL(file);
		reader.onload = () => {
			debugger;
			const promotion = { ...this.state.promotion };
			promotion.headerImage = reader.result;

			this.setState({ promotion });
		};
		reader.onerror = error => {
			console.log('Error: ', error);
		};
	}

	renderUserAppearance() {
		const { t } = this.props;

		const subIndexCaption = this.getLocalisedParamStringValue(
			promotionsUtil.promotionParameters.PROMOTION_SUB_INDEX
		);
		const subIndex = subIndexCaption ? (
			<div
				style={{
					position: 'absolute',
					top: '24px',
					right: '0px',
					color: 'white',
					backgroundColor: 'red',
					padding: '10px',
					paddingRight: '29px',
					borderRadius: '10px 0px 00px 24px',
					textAlign: 'right'
				}}
			>
				{subIndexCaption}
			</div>
		) : (
			<></>
		);

		return (
			<>
				<Row>
					<Col xs={12} sm={6} md={6} lg={6}>
						<div
							style={{
								position: 'relative',
								maxHeight: '600px',
								overflow: 'scroll'
							}}
						>
							<div>
								<img
									src={this.state.promotion.headerImage}
									style={{
										maxWidth: '100%',
										minHeight: '72px'
									}}
								></img>
							</div>
							{subIndex}
							<div
								dangerouslySetInnerHTML={{
									__html: this.getLocalisedParamStringValue(
										promotionsUtil.promotionParameters.PROMOTION_DESCRIPTION
									)
								}}
							></div>
						</div>
					</Col>
					<Col xs={12} sm={6} md={6} lg={6}>
						<Form.Group>
							{this.renderLanguageSelector()}

							<Row className={classes.padding}>
								<Form.Label style={{ fontWeight: 'bold' }}>
									{t(
										'promotionManager.addPromotion.promotionVisibleName.title'
									)}
								</Form.Label>
								<HelperTooltip
									height={'100px'}
									width={'250px'}
									direction={'right'}
									id={'name'}
									title={t(
										'promotionManager.addPromotion.promotionVisibleName.tooltip.title'
									)}
									content={t(
										'promotionManager.addPromotion.promotionVisibleName.tooltip.content'
									)}
								></HelperTooltip>
							</Row>

							<Form.Control
								required
								id="visibleName"
								name="visibleName"
								type="text"
								className={classes.BottomMargin}
								value={this.getLocalisedParamStringValue(
									promotionsUtil.promotionParameters.PROMOTION_VISIBLE_NAME
								)}
								onChange={e =>
									this.setLocalisedParamValue(
										promotionsUtil.promotionParameters.PROMOTION_VISIBLE_NAME,
										e.target.value
									)
								}
							/>

							<Row className={classes.padding}>
								<Form.Label style={{ fontWeight: 'bold' }}>
									{t('promotionManager.addPromotion.promotionSubTitle.title')}
								</Form.Label>
								<HelperTooltip
									height={'100px'}
									width={'250px'}
									direction={'right'}
									id={'name'}
									title={t(
										'promotionManager.addPromotion.promotionSubTitle.tooltip.title'
									)}
									content={t(
										'promotionManager.addPromotion.promotionSubTitle.tooltip.content'
									)}
								></HelperTooltip>
							</Row>

							<Form.Control
								id="subtitle"
								name="subtitle"
								type="text"
								className={classes.BottomMargin}
								value={this.getLocalisedParamStringValue(
									promotionsUtil.promotionParameters.PROMOTION_SUB_INDEX
								)}
								onChange={e =>
									this.setLocalisedParamValue(
										promotionsUtil.promotionParameters.PROMOTION_SUB_INDEX,
										e.target.value
									)
								}
							/>

							<Row className={classes.padding}>
								<Form.Label style={{ fontWeight: 'bold' }}>
									{t(
										'promotionManager.addPromotion.promotionDescription.title'
									)}
								</Form.Label>
							</Row>

							<ReactQuill
								theme="snow"
								name="description"
								className={classes.BottomMargin}
								value={this.getLocalisedParamStringValue(
									promotionsUtil.promotionParameters.PROMOTION_DESCRIPTION
								)}
								onChange={value =>
									this.setLocalisedParamValue(
										promotionsUtil.promotionParameters.PROMOTION_DESCRIPTION,
										value
									)
								}
							/>

							<hr></hr>
							<Row className={classes.padding}>
								<Form.Label style={{ fontWeight: 'bold' }}>
									{t('promotionManager.addPromotion.headerImage.title')}
								</Form.Label>
							</Row>

							<Files
								multiple={false}
								maxSize="10mb"
								accept={['image/jpg', 'image/jpeg']}
								onSuccess={files => {
									if (files && files.length > 0) {
										this.getBase64(files[0].src.file);
									}
								}}
								onError={errors => {
									debugger;
									this.setState({ errors });
								}}
							>
								{({ browseFiles, getDropZoneProps, getLabelProps }) => (
									<>
										<div {...getDropZoneProps({ className: 'myDropZone' })} />
										<Button
											variant="success"
											className="DefaultButton"
											onClick={browseFiles}
										>
											<i class="fa fa-plus mr-2 " aria-hidden="true"></i>
											{t('promotionManager.addPromotion.selectFile')}
										</Button>
									</>
								)}
							</Files>
						</Form.Group>
					</Col>
				</Row>
			</>
		);
	}

	isNotificationEnabled = () => {
		return (
			promotionsUtil.getParamValueByName(
				this.state.promotion,
				promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_EMAIL
			) == 'Y' ||
			promotionsUtil.getParamValueByName(
				this.state.promotion,
				promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_APP
			) == 'Y'
		);
	};

	renderUserNotifications() {
		const { t } = this.props;
		const curNotifcationDateTime = promotionsUtil.getParamValueByName(
			this.state.promotion,
			promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_TIME
		);

		return (
			<>
				<Row>
					<Form.Label style={{ fontWeight: 'bold' }}>
						{t('promotionManager.addPromotion.promotionNotificationMeans')}
					</Form.Label>

					<Col xs={6} sm={6} md={6} lg>
						<Form.Check
							id="cbNotificationEmail"
							name="cbNotificationEmail"
							type="checkbox"
							label={t(
								'promotionManager.addPromotion.promotionNotificationViaEmail'
							)}
							checked={
								promotionsUtil.getParamValueByName(
									this.state.promotion,
									promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_EMAIL
								) == 'Y'
							}
							onChange={e => {
								const promotion = { ...this.state.promotion };
								promotionsUtil.setParamValue(
									promotion,
									promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_EMAIL,
									e.target.checked ? 'Y' : 'N'
								);
								this.setState({ promotion });
							}}
						></Form.Check>
					</Col>
					<Col xs={6} sm={6} md={6} lg>
						<Form.Check
							id="cbNotificationEmail"
							name="cbNotificationEmail"
							type="checkbox"
							label={t(
								'promotionManager.addPromotion.promotionNotificationViaApp'
							)}
							checked={
								promotionsUtil.getParamValueByName(
									this.state.promotion,
									promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_APP
								) == 'Y'
							}
							onChange={e => {
								const promotion = { ...this.state.promotion };
								promotionsUtil.setParamValue(
									promotion,
									promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_APP,
									e.target.checked ? 'Y' : 'N'
								);
								this.setState({ promotion });
							}}
						></Form.Check>
					</Col>
				</Row>
				<Container>
					<Row>
						<Form.Label style={{ fontWeight: 'bold' }}>
							{t(
								'promotionManager.addPromotion.promotionNotificationTime.title'
							)}
						</Form.Label>
						<HelperTooltip
							height={'100px'}
							width={'300px'}
							direction={'top'}
							id={'usersToolTip'}
							title={t(
								'promotionManager.addPromotion.promotionNotificationTime.tooltip.title'
							)}
							content={t(
								'promotionManager.addPromotion.promotionNotificationTime.tooltip.content'
							)}
						></HelperTooltip>
						<Col xs={12} sm={12} md={12} lg={12}>
							<Form.Control
								name="notificationDateTime"
								type="datetime-local"
								required={this.isNotificationEnabled()}
								disabled={!this.isNotificationEnabled()}
								value={
									curNotifcationDateTime
										? moment(curNotifcationDateTime).format('YYYY-MM-DD HH:mm')
										: ''
								}
								onChange={e => {
									const promotion = { ...this.state.promotion };
									promotionsUtil.setParamValue(
										promotion,
										promotionsUtil.promotionParameters
											.promotionNotificationTime,
										e.target.value
									);
									this.setState({ promotion });
								}}
							/>
						</Col>
					</Row>
					<Row>
						<Form.Label style={{ fontWeight: 'bold' }}>
							{t(
								'promotionManager.addPromotion.promotionNotificationTopic.title'
							)}
						</Form.Label>
						<HelperTooltip
							height={'100px'}
							width={'300px'}
							direction={'top'}
							id={'usersToolTip'}
							title={t(
								'promotionManager.addPromotion.promotionNotificationTopic.tooltip.title'
							)}
							content={t(
								'promotionManager.addPromotion.promotionNotificationTopic.tooltip.content'
							)}
						></HelperTooltip>
						<Col xs={12} sm={12} md={12} lg={12}>
							<Form.Control
								id="notificationTopic"
								name="notificationTopic"
								type="text"
								required={this.isNotificationEnabled()}
								disabled={!this.isNotificationEnabled()}
								value={promotionsUtil.getParamValueByName(
									this.state.promotion,
									promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_TOPIC
								)}
								onChange={e => {
									const promotion = { ...this.state.promotion };
									promotionsUtil.setParamValue(
										promotion,
										promotionsUtil.promotionParameters
											.promotionNotificationTopic,
										e.target.value
									);
									this.setState({ promotion });
								}}
							/>
						</Col>
					</Row>
					<Row className={classes.padding}>
						<Form.Label style={{ fontWeight: 'bold' }}>
							{t(
								'promotionManager.addPromotion.promotionNotificationUsers.title'
							)}
						</Form.Label>
						<HelperTooltip
							height={'100px'}
							width={'300px'}
							direction={'top'}
							id={'usersToolTip'}
							title={t(
								'promotionManager.addPromotion.promotionNotificationUsers.tooltip.title'
							)}
							content={t(
								'promotionManager.addPromotion.promotionNotificationUsers.tooltip.content'
							)}
						></HelperTooltip>
					</Row>
					<Row>
						<Col xs={12} sm={12} md={12} lg={12}>
							<SelectedUsers
								disabled={!this.isNotificationEnabled()}
								selectedUsers={promotionsUtil.getParamValueByName(
									this.state.promotion,
									promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_USERS
								)}
								required={this.isNotificationEnabled()}
								onChange={e => {
									const promotion = { ...this.state.promotion };
									promotionsUtil.setParamValue(
										promotion,
										promotionsUtil.promotionParameters
											.promotionNotificationUsers,
										e.target.value
									);
									this.setState({ promotion });
								}}
								onShowUserSelector={() =>
									this.showUserSelectorDialog(
										promotionsUtil.promotionParameters
											.promotionNotificationUsers
									)
								}
							/>
						</Col>
					</Row>
					<Row className={classes.padding}>
						<Form.Label style={{ fontWeight: 'bold' }}>
							{t(
								'promotionManager.addPromotion.promotionNotificateMessage.title'
							)}
						</Form.Label>
						<HelperTooltip
							height={'100px'}
							width={'300px'}
							direction={'top'}
							id={'usersToolTip'}
							title={t(
								'promotionManager.addPromotion.promotionNotificateMessage.tooltip.title'
							)}
							content={t(
								'promotionManager.addPromotion.promotionNotificateMessage.tooltip.content'
							)}
						></HelperTooltip>
					</Row>
					<ReactQuill
						id="ReactQuil"
						theme="snow"
						name="notificationMessage"
						ref={this.ReactQuillRef}
						className={classes.BottomMargin}
						readOnly={!this.isNotificationEnabled()}
						required={this.isNotificationEnabled()}
						value={promotionsUtil.getParamValueByName(
							this.state.promotion,
							promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_MESSAGE
						)}
						onChange={value => {
							debugger;
							const promotion = { ...this.state.promotion };
							promotionsUtil.setParamValue(
								promotion,
								promotionsUtil.promotionParameters.PROMOTION_NOTIFICATION_MESSAGE,
								value
							);
							this.setState({ promotion });
						}}
					/>
				</Container>
			</>
		);
	}

	render() {
		const { t } = this.props;

		return (
			<Form
				noValidate
				validated={this.state.validated}
				id={'editPromotionForm'}
			>
				{this.renderUserSelectorDialog()}
				<Tabs
					defaultActiveKey="general"
					id="promotionEditorTabs"
					className="mb-3"
				>
					<Tab
						eventKey="general"
						title={t('promotionManager.addPromotion.generalTab')}
					>
						{this.renderGeneralTab()}
					</Tab>
					<Tab
						eventKey="intervalLimit"
						title={t('promotionManager.addPromotion.intervalTab')}
					>
						{this.renderTimerIntervalTab()}
					</Tab>

					<Tab
						eventKey="userLimit"
						title={t('promotionManager.addPromotion.userLimitsTab')}
					>
						{this.renderUserLimits()}
					</Tab>
					<Tab
						eventKey="appearance"
						title={t('promotionManager.addPromotion.inAppAppearanceTab')}
					>
						{this.renderUserAppearance()}
					</Tab>
					<Tab
						eventKey="notification"
						title={t('promotionManager.addPromotion.notificationTab')}
					>
						{this.renderUserNotifications()}
					</Tab>
				</Tabs>

				<Button
					variant="success"
					className="DefaultButton"
					onClick={() => this.validationHandler()}
				>
					<i className="fa fa-floppy-o mr-2" />{' '}
					{t('promotionManager.addPromotion.savebutton')}
				</Button>
			</Form>
		);
	}
}

export default withTranslation()(EditPromotionDialog);
